module.exports = __webpack_public_path__ + "static/media/musical.ed0a6a8c.jpg";